import React from 'react';

import { HomeLayout } from 'modules/home/components/HomeLayout';
import { onboardingElementIds } from 'services/onboarding/constants';
import { CalendarOrganizationList } from 'modules/calendar/components/CalendarOrganizationList';

export const HomeCalendarMeetingsTab: React.FC = () => {
  return (
    <HomeLayout>
      <div id={onboardingElementIds.homePageContainer}>
        <CalendarOrganizationList />
      </div>
    </HomeLayout>
  );
};
